'use strict';

export function init() {
	const customSelects = document.querySelectorAll(".category-switcher");

	for (let i = 0; i < customSelects.length; i++) {
		const select = customSelects[i].querySelector("select");
		const options = select.querySelectorAll("option");
		const selectedOption = options[select.selectedIndex];
		const selectSelected = document.createElement("div");
		selectSelected.className = "select-selected";
		selectSelected.innerHTML = selectedOption.innerHTML;
		customSelects[i].appendChild(selectSelected);

		const selectItems = document.createElement("div");
		selectItems.className = "select-items select-hide";

		for (let j = 1; j < options.length; j++) {
			const option = options[j];
			const selectOption = document.createElement("a");
			selectOption.innerHTML = option.innerHTML;
			selectOption.href = option.value;
			selectOption.addEventListener("click", function() {
				select.selectedIndex = j;
				selectSelected.innerHTML = option.innerHTML;

				for (let k = 0; k < this.parentNode.children.length; k++) {
					this.parentNode.children[k].classList.remove("same-as-selected");
				}

				this.classList.add("same-as-selected");
				selectSelected.click();
			});

			selectItems.appendChild(selectOption);
		}

		customSelects[i].appendChild(selectItems);

		selectSelected.addEventListener("click", function(e) {
			e.stopPropagation();
			closeAllSelect(selectItems);
			selectItems.classList.toggle("select-hide");
			selectSelected.classList.toggle("select-arrow-active");
			this.parentNode.classList.toggle("category-switcher--open");
			document.body.classList.toggle("category-switcher-open")
		});
	}

	function closeAllSelect(exceptThis) {
		const selectItems = document.querySelectorAll(".select-items");

		for (let i = 0; i < selectItems.length; i++) {
			if (selectItems[i] !== exceptThis) {
				selectItems[i].classList.add("select-hide");
				selectItems[i].previousElementSibling.classList.remove("select-arrow-active");
				selectItems[i].parentNode.classList.remove("category-switcher--open");
			}
		}
	}

	document.addEventListener("click", function(event) {
		closeAllSelect(event.target.closest(".select-items"));
	});
}
